<template>


  <div
      class=" flex flex-grow  w-full outline-0 dark:rounded overflow-hidden bg-trader-gray ">
    <div class="overflow-auto outline-0" @click="focus" ref="tableContainer" tabindex="0">
      <table class="w-full  rounded  select-none table-fixed flex-grow outline-0">

        <thead class="sticky top-0">
        <tr class="bg-trader-darkest-gray text-white h-8 text-left ">
          <template v-for="(header, index) in props.header" :key="index">
            <th :style="{ width: columnWidths[header.field] + 'px' }"
                class="p-0 m-0 relative text-nowrap overflow-hidden text-ellipsis">

              <div class="flex">
                <span class="text-ellipsis flex-grow overflow-hidden pl-2">
                {{ header.title }}
                  </span>
                <div class="cursor-col-resize  w-[2px] flex-shrink-0  bg-trader-dark-gray"
                     @mousedown="startResize($event, header.field)"></div>
              </div>
            </th>
          </template>
          <th class=""></th>
        </tr>

        </thead>
        <tbody>
        <tr class="h-8" v-for="(dataRow, rowIndex) in props.dataRows" :key="rowIndex"
            :class="[ selectedRows.includes(rowIndex) ? 'bg-trader-blue text-white' : rowIndex % 2 != 0 ? 'bg-trader-dark-gray' : 'bg-trader-gray' ]"
            @mousedown="onRowMouseDown(rowIndex, $event)"
            @mousemove="onRowMouseMove(rowIndex, $event)"
            @mouseup="onRowMouseUp($event)">
          <template v-for="(header, columnIndex) in props.header">
            <td class="px-2 overflow-hidden whitespace-nowrap text-ellipsis ">
              <slot name="cell" :row="dataRow" :field="header.field" :selected="selectedRows.includes(rowIndex)">
                <div v-html="formatCellValue(dataRow, header.field, selectedRows.includes(rowIndex))"></div>
              </slot>
            </td>
          </template>
          <td></td>
        </tr>
        <tr class="flex-grow"></tr>
        </tbody>

      </table>
    </div>

    <!-- Bild-Modal -->
    <div v-if="showImageModal && openPicture"
         class="  fixed inset-0 flex flex-col items-center justify-center z-50" @click="closeModal">
      <div class="rounded-lg shadow-lg bg-trader-light-gray" @click.stop>
        <div class=" p-4  w-[100vh] h-[100vh] flex items-center justify-center"  @dragstart="onDragStart($event,rowsData.find(row => row.imgLocNewFilepath == currentImagePath))">
          <img
              :src="currentImagePath"
              alt="Ausgewähltes Bild"
              class="max-w-full max-h-full object-contain"
          />
        </div>

        <div v-if="rowsData.length > 1" class="flex gap-2 w-[600px] h-[100px] overflow-auto p-2">
          <template v-for="row in rowsData">
            <div class=" p-2  shadow-lg min-w-[100px] flex items-center justify-center"  @dragstart="onDragStart($event,row)"
                 :class="currentImagePath === row.imgLocNewFilepath ? 'bg-trader-blue ' : 'bg-trader-gray'"
                 @click.stop="changeCurrentImage(row)">
              <img
                  :src="row.imgLocNewFilepath"
                  class="max-w-full max-h-full object-contain"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup lang="ts">
import {onMounted, onUnmounted, ref, watch} from 'vue'

const selectedRows = ref<number[]>([]);
const rowsData = ref([]);
const columnWidths = ref({});
let currentColumn = null;
let startX = 0;
let startWidth = 0;

const showImageModal = ref(false);
const currentImagePath = ref('');


const props = defineProps({
  dataRows: Array,
  header: Array,
  style: Object,
  openPicture: {
    type: Boolean,
    default: false,
  },
  formatCellValue: {
    type: Function,
    required: false,
    default: (dataRow: any, field: string) => {
      return dataRow[field];
    },
  },

  numberOfDataRows: Number,
  onSelectionChange: {
    type: Function,
    required: false,
    default: (rows: any[]) => {
    },
  },
  onPageStep: {
    type: Function,
    required: false,
    default: (step: number) => {
    },
  },
  singleSelection: {
    type: Boolean,
    default: false,
  },
  selectedIndex: {
    type: Number,
    default: 0,
  },
});

function changeCount(type: PageNavigation) {
  if (type === PageNavigation.PLUS) {
    if (count.value < props.numberOfPictures) {
      count.value += 1;
    }
  } else if (type === PageNavigation.MINUS) {
    if (count.value > 1) {
      count.value -= 1;
    }
  } else if (type === PageNavigation.START) {
    count.value = 1;
  } else if (type === PageNavigation.END) {
    count.value = props.numberOfPictures;
  }
  props.onPageStep(count.value);
}

function closeModal() {
  showImageModal.value = false;
}

const onDragStart = (event, picture) => {

  event.preventDefault(); // Standardverhalten verhindern


  let filePath = picture.imgLocOrgFilepath;
  filePath = filePath.replace(/\*/g, "%2A");


  if (window?.electronAPI) {
    window?.electronAPI.startDrag(filePath); // Drag-Aktion starten
  }
}


function changeCurrentImage(row) {
  currentImagePath.value = row.imgLocNewFilepath;

}

function startResize(event: MouseEvent, column: string) {
  currentColumn = column;
  startX = event.pageX;
  startWidth = columnWidths.value[column];

  document.addEventListener('mousemove', resizeColumn);
  document.addEventListener('mouseup', stopResize);
}

function resizeColumn(event: MouseEvent) {
  if (!currentColumn) return;
  const dx = event.pageX - startX;

  // Calculate new width of current column
  let newWidth = startWidth + dx;
  newWidth = Math.max(50, newWidth); // Minimum width 50px

  // Update the width of current column
  columnWidths.value[currentColumn] = newWidth;
}

function stopResize() {
  document.removeEventListener('mousemove', resizeColumn);
  document.removeEventListener('mouseup', stopResize);
  currentColumn = null;
}


const tableContainer = ref<HTMLElement | null>(null);

const isMouseDown = ref(false);
const startRowIndex = ref<number | null>(null);

function onRowMouseDown(index: number, event: MouseEvent) {
  event.stopPropagation();
  event.preventDefault();

  if (props.singleSelection) {
    // Bei Einzel-Auswahl direkt die Zeile auswählen, ohne Drag-Selection zu starten.
    selectRow(index, event);
    return;
  }

  // Bestehende Logik für Mehrfachauswahl:
  if (event.shiftKey || event.metaKey || event.ctrlKey) {
    isMouseDown.value = false;
    selectRow(index, event);
  } else {
    isMouseDown.value = true;
    startRowIndex.value = index;
    selectRow(index, event);
  }
}


function onRowMouseMove(index: number, event: MouseEvent) {
  if (isMouseDown.value && startRowIndex.value !== null) {
    if (event.shiftKey || event.metaKey || event.ctrlKey) {
      // Do not proceed with drag selection when shift or command is pressed
      return;
    }
    // Select range from startRowIndex to current index
    let start = Math.min(startRowIndex.value, index);
    let end = Math.max(startRowIndex.value, index);
    selectedRows.value = [];
    for (let i = start; i <= end; i++) {
      selectedRows.value.push(i);
    }
    // Emit the selection change
    const rows = selectedRows.value.map(idx => props.dataRows[idx]);
    rowsData.value = rows;
    focus();
    props.onSelectionChange(rows);
  }
}

function onRowMouseUp(event: MouseEvent) {
  isMouseDown.value = false;
}

function onGlobalMouseUp(event: MouseEvent) {
  isMouseDown.value = false;
}

function selectRow(index: number, event: MouseEvent) {
  if (props.singleSelection) {
    // Bei Einzel-Auswahl wird immer nur ein Datensatz ausgewählt,
    // unabhängig von gedrückten Modifier-Tasten.
    selectedRows.value = [index];
  } else {
    // Bestehende Logik für Mehrfachauswahl:
    if (event.metaKey || event.ctrlKey) {
      // Toggle selection
      if (selectedRows.value.includes(index)) {
        selectedRows.value = selectedRows.value.filter(i => i !== index);
      } else {
        selectedRows.value.push(index);
      }
    } else if (event.shiftKey) {
      // Range selection
      if (selectedRows.value.length === 0) {
        selectedRows.value.push(index);
      } else {
        let lastSelectedIndex = selectedRows.value[selectedRows.value.length - 1];
        let start = Math.min(lastSelectedIndex, index);
        let end = Math.max(lastSelectedIndex, index);
        selectedRows.value = [];
        for (let i = start; i <= end; i++) {
          selectedRows.value.push(i);
        }
      }
    } else {
      selectedRows.value = [index];
    }
  }

  // Aktualisiere currentImagePath basierend auf der ersten ausgewählten Zeile:
  if (selectedRows.value.length > 0) {
    currentImagePath.value = props.dataRows[selectedRows.value[0]].imgLocNewFilepath;
  } else {
    currentImagePath.value = "";
  }

  // Scrollt zur ausgewählten Zeile, falls sie nicht sichtbar ist
  const selectedRow = tableContainer.value?.querySelector(`tr:nth-child(${index + 1})`);
  if (selectedRow) {
    selectedRow.scrollIntoView({block: 'nearest'});
  }

  // Auswahl-Änderung an den Parent-Komponenten übermitteln
  const rows = selectedRows.value.map(idx => props.dataRows[idx]);
  focus();
  rowsData.value = rows;
  props.onSelectionChange(rows);
}


function onKeyDown(e: KeyboardEvent) {

  if (document.activeElement !== tableContainer.value) {

    //show preview / zeige vorschau bild
    if (e.key === ' ') {
      showImageModal.value = !showImageModal.value;
    } else if (e.key === 'Escape') {
      showImageModal.value = false;
    }
    return;
  }


  e.stopPropagation();
  e.preventDefault();

  const limit = props.dataRows.length;
  let newRowIndex = -1;

  
  if (props.singleSelection) {
    // Falls noch keine Zeile ausgewählt ist, starte mit dem ersten Element
    newRowIndex = selectedRows.value.length === 0 ? 0 : selectedRows.value[0];

    if (e.key === 'ArrowUp') {
      newRowIndex = newRowIndex - 1;
      if (newRowIndex < 0) newRowIndex = 0;
    } else if (e.key === 'ArrowDown') {
      newRowIndex = newRowIndex + 1;
      if (newRowIndex >= limit) newRowIndex = limit - 1;
    }

    selectedRows.value = [newRowIndex];
  } else {
    // Bestehende Logik für Mehrfachauswahl:
    let length = selectedRows.value.length;
    selectedRows.value.sort((a, b) => a - b);

    if (e.key === 'ArrowUp') {
      if (length > 0 && e.shiftKey) {
        newRowIndex = selectedRows.value[0] - 1;
        if (newRowIndex >= 0) {
          selectedRows.value.unshift(newRowIndex);
        }
      } else if (length === 1) {
        newRowIndex = selectedRows.value[0] - 1;
        newRowIndex = newRowIndex < 0 ? 0 : newRowIndex;
        selectedRows.value = [newRowIndex];
      } else {
        newRowIndex = selectedRows.value[0];
        selectedRows.value = [selectedRows.value[0]];
      }
      // Bild beim Navigieren nach oben aktualisieren:
      currentImagePath.value = props.dataRows[selectedRows.value[0]].imgLocNewFilepath;
    } else if (e.key === 'ArrowDown') {
      if (length > 0 && e.shiftKey) {
        newRowIndex = selectedRows.value[selectedRows.value.length - 1] + 1;
        if (newRowIndex < limit) {
          selectedRows.value.push(newRowIndex);
        }
      } else if (length === 1) {
        newRowIndex = selectedRows.value[0] + 1;
        newRowIndex = newRowIndex >= limit ? limit - 1 : newRowIndex;
        selectedRows.value = [newRowIndex];
      } else {
        newRowIndex = selectedRows.value[selectedRows.value.length - 1];
        selectedRows.value = [selectedRows.value[length - 1]];
      }
      // Bild beim Navigieren nach unten aktualisieren:
      currentImagePath.value = props.dataRows[selectedRows.value[0]].imgLocNewFilepath;
    } else if (e.key === ' ') {
      if (currentImagePath.value === '') {
        selectedRows.value = [0];
        currentImagePath.value = props.dataRows[0].imgLocNewFilepath;
      }
      
      showImageModal.value = !showImageModal.value;
    }
    if (showImageModal.value) {
      if (e.key === 'Escape') {
        
        showImageModal.value = false;
      }
    }
  }

  // Scrollt zur ausgewählten Zeile
  const selectedRow = tableContainer.value?.querySelector(`tr:nth-child(${selectedRows.value[0] + 1})`);
  if (selectedRow) {
    const tableHeader = tableContainer.value?.querySelector('thead');
    const rowPosition = selectedRow.getBoundingClientRect().top;
    const headerPosition = tableHeader?.getBoundingClientRect().bottom;
    selectedRow.scrollIntoView({block: 'nearest'});
    if (rowPosition < headerPosition) {
      tableContainer.value?.scrollBy(0, -(headerPosition - rowPosition));
    }
  }

  // Auswahl-Änderung an den Parent-Komponenten übermitteln
  const rows = selectedRows.value.map(idx => props.dataRows[idx]);
  focus();
  rowsData.value = rows;
  props.onSelectionChange(rows);
}

function focus() {
  if (tableContainer.value) {

    tableContainer.value.focus();
  }
}

onMounted(() => {
  if (props.dataRows && props.dataRows.length > 0) {
    selectedRows.value = [props.selectedIndex];
  }
  window.addEventListener('keydown', onKeyDown);
  window.addEventListener('mouseup', onGlobalMouseUp);

  const maxWidth = tableContainer.value?.offsetWidth - 5;

  let totalWidth = 0;
  let countEmptyWidth = 0;
  props.header.forEach(header => {
    if (header.width !== null && header.width !== 0) {
      columnWidths.value[header.field] = header.width;
      totalWidth += header.width;
    } else {
      countEmptyWidth++;
    }
  });

  props.header.forEach(header => {
    if (header.width === null || header.width === 0) {
      columnWidths.value[header.field] = (maxWidth - totalWidth) / countEmptyWidth;
    }
  });

});
// wenn sich dataRows ändert, dann die erste Zeile erneut auswählen
watch(() => props?.dataRows, (newDataRows) => {

  if (selectedRows.value.length === 0) {
    selectedRows.value = [0];
    props.onSelectionChange(newDataRows.slice(0, 1));
  } else if (newDataRows && newDataRows.length > 0) {
    // Nehme den ersten ausgewählten Index oder 0, falls keiner gesetzt ist
    const selectedIndex = selectedRows.value[0] ?? 0;
    selectedRows.value = [selectedIndex];
    props.onSelectionChange(newDataRows.slice(selectedIndex, selectedIndex + 1));
  }

});
onUnmounted(() => {
  window.removeEventListener('keydown', onKeyDown);
  window.removeEventListener('mouseup', onGlobalMouseUp);
});

</script>
